import {Injectable} from '@angular/core';
import {Headers, Http, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';
import 'rxjs/add/operator/map';

@Injectable()
export class DownloadExcelService {
    private header: Headers;
    private endPoint: string;

    constructor(private http: Http, private router: Router) {
        let contentHeaders = new Headers();
        this.header = contentHeaders;
    }

    exportExcel(url: string, name: string): Observable<any> {
        this.header.set('x-token', localStorage.getItem('Access-Token'));
        return this.http.get(environment.api + url, {
            headers: this.header,
            responseType: ResponseContentType.Blob
        }).map((res: any) => {
            let url = window.URL.createObjectURL(res.blob());
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.href = url;
            a.download = name + '.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/common/services/DownloadExcel.service.ts